import Model from 'flarum/common/Model';

/*
 * The gallery's models, as far as the client-side store is concerned.
 *
 * 🚨 These exist for NOTIFICATIONS, and registering them is not optional.
 *
 * `/api/notifications` includes each notification's subject, and Flarum's store
 * does `new this.models[type](data, this)` with no fallback whatsoever — an
 * unregistered type is not a generic record, it is `this.models[type] is not a
 * constructor`, thrown while the notification list is being built. That kills
 * the whole list, for every notification on it, including everybody else's.
 *
 * It is the same trap as the missing API resource on the PHP side, one layer
 * up, and it fails just as loudly and just as far from its cause.
 */
export class AtriumImage extends Model {}
Object.assign(AtriumImage.prototype, {
  title: Model.attribute('title'),
  albumTitle: Model.attribute('albumTitle')
});
export class AtriumAlbum extends Model {}
Object.assign(AtriumAlbum.prototype, {
  title: Model.attribute('title'),
  slug: Model.attribute('slug')
});